'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[reporting-maximizer global-error]', error);
  }, [error]);

  return (
    <html lang="en" suppressHydrationWarning>
      <body suppressHydrationWarning style={{
        margin: 0, padding: '32px', background: '#000', color: '#f1f3f5',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 13, lineHeight: 1.5,
      }}>
        <h1 style={{ fontSize: 18, color: '#ef6a6a', margin: '0 0 16px' }}>
          Reporting Maximizer — fatal error
        </h1>
        <div style={{ marginBottom: 12 }}>
          <strong>Message:</strong> {String(error?.message ?? 'unknown')}
        </div>
        {error?.digest ? (
          <div style={{ marginBottom: 12 }}>
            <strong>Digest:</strong> {error.digest}
          </div>
        ) : null}
        <pre style={{
          background: '#111', padding: 12, borderRadius: 6,
          overflow: 'auto', maxWidth: '100%', whiteSpace: 'pre-wrap',
        }}>
{String(error?.stack ?? '')}
        </pre>
        <button
          type="button"
          onClick={reset}
          style={{
            marginTop: 16, padding: '8px 16px', borderRadius: 6,
            background: '#22c55e', color: '#000', border: 'none', cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
